declare const $: any; // jQuery global
import { BookingFormValidator } from "./booking-form-validator";

function registerMinAgeValidator(): void {
    if (!$ || !$.validator) return;

    $.validator.addMethod("minage", function (value: string, _element: any, params: any) {
        if (!value) return true; // let 'required' handle empty

        const ageCheckRequired = $("#event-delegates").data("ageCheckRequired");
        if (!ageCheckRequired) return true;

        const dob = new Date(value);
        if (isNaN(dob.getTime())) return false;

        const today = new Date();
        let age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
            age--;
        }

        const minAge = parseInt(params, 10) || 18;
        return age >= minAge;
    }, "Delegate must be at least 18 years old.");

    $.validator.unobtrusive.adapters.add("minage", ["min"], function (options: any) {
        options.rules["minage"] = options.params.min;
        options.messages["minage"] = options.message;
    });
}


function validateEventForm(): void {
    //let isValid = true;

    //$("input[required], select[required]").each(function (this: any) {
    //    if (!$(this).val()) isValid = false;
    //});

    //$('input[id*="__Validated"]').each(function (this: any) {
    //    if ($(this).val()?.toString().toLowerCase() !== "true") isValid = false;
    //});

    //$("#event-checkout-btn button").prop("disabled", !isValid);
}

function associateValidationClicks(): void {
    // prevent stacking handlers
    $(".input-del-email")
        .off("blur")
        .on("blur", function (this: any) {
            const input = $(this);

            input.addClass("input-loading");
            input.removeClass("border-success border-2");

            const index = input.data("index");
            const email = input.val();

            if (!email) {
                input.removeClass("input-loading");
                validateEventForm();
                return;
            }

            const validationElem = $(`.validated-member-txt[data-index=${index}]`);
            validationElem.hide();

            const encodedEmail = encodeURIComponent(email);

            const eventId = $("#event-delegates").data("eventId") ?? "";

            $.ajax({
                method: "GET",
                url: `/umbraco/surface/eventbookingsurface/validatemembership?email=${encodedEmail}&delIndex=${index}&eventId=${eventId}`,
                async: true
            }).done(function (result: any) {
                input.removeClass("input-loading");

                if (!result || !result.valid) {
                    validationElem.html(`<b>${email}</b> ${result?.reason || "could not be added."}`);
                    validationElem.removeClass("text-success").addClass("text-red").show();

                    input.removeClass("border-success border-2").addClass("input-validation-error");
                    $(`#Delegates_${index}__Validated`).val("false");
                } else {
                    validationElem.html(`<b>${email}</b> can attend this event.`);
                    validationElem.removeClass("text-red").addClass("text-success").show();

                    input.removeClass("input-validation-error").addClass("border-success border-2");
                    $(`#Delegates_${index}__Validated`).val("true");
                }

                validateEventForm();
            });
        });

    $("input[required], select[required], .input-del-email")
        .off("change", validateEventForm)
        .on("change", validateEventForm);
}

// Used in instances of non-payment
function submitEventCheckout(): void {
    const bookingForm = $("#EventBookingForm");

    if (validateEventCheckout(bookingForm)) {
        bookingForm.submit();
        $("#updateButton").prop("disabled", true);
    }
}

// expose globally for inline onclick
(window as any).submitEventCheckout = submitEventCheckout;

function validateEventCheckout(form: any): boolean {
const nativeForm = document.getElementById("EventBookingForm") as HTMLFormElement | null;
const addressValid = nativeForm ? BookingFormValidator.validateCheckoutAddresses(nativeForm) : true;

// Unobtrusive validation
    let formValid = form.valid();

    // Confirm Email must match Email
    const confirmedEmail = $("input[name=ConfirmedEmail]");
    if (!!confirmedEmail.val() && confirmedEmail.val() != $("input[name=Email]").val()) {
        formValid = false;

        confirmedEmail.addClass("input-validation-error");

        const ceValidationMsg = $("span[data-valmsg-for=ConfirmedEmail]");
        ceValidationMsg.removeClass();
        ceValidationMsg.addClass("field-validation-error");
        ceValidationMsg.text("This must match your email to confirm.");
    }

    // Billing Confirm Email must match Billing Email
    const billingConfirmedEmail = $("input[name=BillingConfirmedEmail]");
    if (!!billingConfirmedEmail.val() && billingConfirmedEmail.val() != $("input[name=BillingEmail]").val()) {
        formValid = false;

        billingConfirmedEmail.addClass("input-validation-error");

        const bceValidationMsg = $("span[data-valmsg-for=BillingConfirmedEmail]");
        bceValidationMsg.removeClass();
        bceValidationMsg.addClass("field-validation-error");
        bceValidationMsg.text("This must match your email to confirm.");
    }

    return addressValid && formValid;
}

function updateEventDelegates(form: any, quantity: number): void {
    const delegates = form.find("#event-delegates");
    const checkoutBtn = form.find("#event-checkout-btn");
    const delegateInfoHeader = form.find("#event-delegate-info-header");

    if (quantity === 0) {
        checkoutBtn.hide();
        delegateInfoHeader.hide();
        delegates.html("");
        return;
    }

    const rows = delegates.children(".delegate-form");
    const currentCount = rows.length;

    if (currentCount > quantity) {
        for (let i = currentCount - 1; i >= quantity; i--) {
            rows.eq(i).remove();
        }
    } else if (currentCount < quantity) {
        const temp = $("template#event-delegate-template")[0] as HTMLTemplateElement | undefined;
        if (!temp) {
            console.warn("No <template id='event-delegate-template'> found for delegate rows.");
        } else {
            // Label comes from the "Event Booking Delegate" dictionary item so JS-added rows match the
            // server-rendered ones; escaped because it's spliced into the template's HTML
            const label = String(delegates.data("delegateLabel") || "Delegate");
            const safeLabel = $("<div>").text(label).html();
            for (let i = currentCount; i < quantity; i++) {
                const html = temp.innerHTML
                    .replace(/\{\{index\}\}/g, i.toString())
                    .replace(/\{\{delegate_title\}\}/g, `${safeLabel} ${i + 1}`);
                delegates.append(html);
            }
        }
    }

    delegateInfoHeader.show();
    checkoutBtn.show();
    associateAssignToSelf();
    reparseValidation();
}

function reparseValidation(): void {
    const form = $("#EventBookingPageForm");
    if (form.length && $.validator?.unobtrusive?.parse) {
        form.removeData("validator").removeData("unobtrusiveValidation");
        $.validator.unobtrusive.parse(form);
    }
}

function clearAssignToSelfFields(index: any): void {
    $(`#Delegates_${index}__Salutation`).val("");
    $(`#Delegates_${index}__FirstName`).val("");
    $(`#Delegates_${index}__LastName`).val("");
    $(`#Delegates_${index}__EmailAddress`).val("");
    $(`#Delegates_${index}__DateOfBirth`).val("");
}

function assignToSelfFields(index: any): any {
    return $(`#Delegates_${index}__Salutation, #Delegates_${index}__FirstName, #Delegates_${index}__LastName, #Delegates_${index}__EmailAddress, #Delegates_${index}__DateOfBirth`);
}

// Greys out and locks the "assign to me" attendee's own details once they're populated from
// their profile - editing them is a source of booking errors, so unlike the other delegate rows
// these fields are read-only for as long as the checkbox stays ticked. `readonly` (not
// `disabled`) is used so the values are still posted with the form.
//
// A field is only locked if the profile actually supplied a value for it - e.g. a contact with
// no Title on file leaves that dropdown blank, and locking a required-but-blank field would trap
// the user: they can't fill it in, but validation won't let them submit without it either.
function lockAssignToSelfFields(index: any): void {
    assignToSelfFields(index).each(function (this: any) {
        const field = $(this);
        if (!field.val()) {
            return;
        }

        field.attr("readonly", "readonly")
            .attr("tabindex", "-1")
            .addClass("delegate-field-readonly");
    });
}

function unlockAssignToSelfFields(index: any): void {
    assignToSelfFields(index)
        .removeAttr("readonly")
        .removeAttr("tabindex")
        .removeClass("delegate-field-readonly");
}

function assignToSelfValidationSpan(index: any): any {
    return $(`span[data-valmsg-for="Delegates[${index}].AssignToSelf"]`);
}

function hideAssignToSelfError(index: any): void {
    assignToSelfValidationSpan(index)
        .empty()
        .removeClass("field-validation-error")
        .addClass("field-validation-valid");
}

function showAssignToSelfError(index: any): void {
    assignToSelfValidationSpan(index)
        .text("We couldn't fetch your details - your session may have expired. Please refresh the page and try again.")
        .removeClass("field-validation-valid")
        .addClass("field-validation-error");
}

function associateAssignToSelf(): void {
    $(document)
        .off("change", "input[id$='__AssignToSelf']")
        .on("change", "input[id$='__AssignToSelf']", function (this: any) {
            const checkbox = $(this);
            const index = checkbox.data("index");
            const delegateContainer = checkbox.closest(".delegate-form");

            if (checkbox.is(":checked")) {
                hideAssignToSelfError(index);

                // A person can only take up one seat - unchecking any other row that was
                // previously assigned to self, reverting it back to a blank guest row.
                $("input[id$='__AssignToSelf']").not(checkbox).filter(":checked").each(function (this: any) {
                    const otherCheckbox = $(this);
                    otherCheckbox.prop("checked", false);
                    clearAssignToSelfFields(otherCheckbox.data("index"));
                    unlockAssignToSelfFields(otherCheckbox.data("index"));
                });

                delegateContainer.addClass("input-loading");
                // Disable the checkbox too, not just the other fields - otherwise the user can
                // uncheck it while the request is still in flight, and the late response's
                // still-checked guard below would never even be needed to trigger.
                const fields = delegateContainer.find("input, select");
                fields.prop("disabled", true);

                $.ajax({
                    method: "GET",
                    url: "/umbraco/surface/eventbookingsurface/getcurrentuserdetails",
                    async: true
                })
                    .done(function (result: any) {
                        // The checkbox may have been unchecked (clearing these fields) while this
                        // request was in flight - applying a late response now would silently
                        // overwrite whatever the user has since cleared or typed over it.
                        if (!checkbox.is(":checked")) {
                            return;
                        }

                        if (result && result.success) {
                            $(`#Delegates_${index}__Salutation`).val(result.title?.toString() ?? "");
                            $(`#Delegates_${index}__FirstName`).val(result.firstName ?? "");
                            $(`#Delegates_${index}__LastName`).val(result.lastName ?? "");
                            $(`#Delegates_${index}__EmailAddress`).val(result.email ?? "");
                            $(`#Delegates_${index}__DateOfBirth`).val(result.dateOfBirth ?? "");

                            // Trigger email validation
                            $(`#Delegates_${index}__EmailAddress`).blur();

                            lockAssignToSelfFields(index);
                        } else {
                            checkbox.prop("checked", false);
                            showAssignToSelfError(index);
                            console.warn("AssignToSelf failed:", result?.errorMessage);
                        }
                    })
                    .fail(function () {
                        checkbox.prop("checked", false);
                        showAssignToSelfError(index);
                        console.error("AssignToSelf: failed to fetch contact details.");
                    })
                    .always(function () {
                        delegateContainer.removeClass("input-loading");
                        fields.prop("disabled", false);
                    });
            } else {
                hideAssignToSelfError(index);
                clearAssignToSelfFields(index);
                unlockAssignToSelfFields(index);
            }
        });
}

// Restore delegate rows and disabled state for package dropdowns when navigating back with a
// pre-selected package. The browser can restore the dropdown's value from history *after* our
// own page-load init has already run and found nothing selected - and it does so silently,
// without a 'change' event - so this is also re-run on 'pageshow', which fires once the
// browser's own restore has settled (and again on a genuine bfcache restore).
function reconcilePreSelectedQuantity(): void {
    const allQuantityDropdowns = $(".ticket-section__table select.event-quantity");
    let preSelectedDropdown: any = null;
    allQuantityDropdowns.each((_: any, dd: any) => {
        if ((parseInt($(dd).val(), 10) || 0) > 0) {
            preSelectedDropdown = dd;
        }
    });
    if (!preSelectedDropdown) {
        return;
    }

    if (allQuantityDropdowns.length > 1) {
        allQuantityDropdowns.each((_: any, dd: any) => {
            dd.disabled = dd !== preSelectedDropdown;
        });
    }

    const initialQuantity = parseInt($(preSelectedDropdown).val(), 10) || 0;
    if (initialQuantity > 0) {
        updateEventDelegates($(preSelectedDropdown).parents("form"), initialQuantity);
    }
}

export function initBookingPage(): void {
    registerMinAgeValidator();

    $(document).on("change", "select.event-quantity", function (this: any) {
        const $this = $(this);
        const form = $this.parents("form");

        const quantity = parseInt(this.value, 10);
        const packageId = $this.data("package");

        form.find("#SelectedPackage").val(packageId);

        const quantityDropdowns = form.find(".ticket-section__table select.event-quantity");
        if (quantityDropdowns.length > 1) {
            quantityDropdowns.each((_: any, dd: any) => {
                dd.disabled = quantity > 0 && dd !== $this[0];
            });
        }

        updateEventDelegates(form, quantity);
        associateValidationClicks();
        validateEventForm();
    });

    // initial setup
    associateValidationClicks();
    associateAssignToSelf();
    reparseValidation();
    validateEventForm();

    reconcilePreSelectedQuantity();
    window.addEventListener("pageshow", reconcilePreSelectedQuantity);

    // Restore visual validation state for delegates pre-filled from session
    $(".input-del-email").each(function(this: any) {
        const input = $(this);
        const index = input.data("index");
        const email = input.val();
        if (email && $(`#Delegates_${index}__Validated`).val()?.toString().toLowerCase() === "true") {
            input.addClass("border-success border-2");
            const msg = $(`.validated-member-txt[data-index=${index}]`);
            msg.html(`<b>${email}</b> can attend this event.`);
            msg.removeClass("text-red").addClass("text-success").show();
        }
    });

    // Restore the "assign to me" lock for delegate rows re-rendered with the checkbox already
    // ticked, e.g. server-side validation sent the form back with values still in place.
    $("input[id$='__AssignToSelf']:checked").each(function (this: any) {
        lockAssignToSelfFields($(this).data("index"));
    });
}